import { IFooter } from "../../interfaces/IFooter.interface";

export interface FooterChild {
  nodeName?: string;
  "cq:panelTitle"?: string;
  isAccordian?: string;
  enableHeaderLanguage?: string;
  columnTitle?: string;
  sectionTitle?: string;
  titleUrl?: string;
  linkTitle?: string;
  linkUrl?: string;
  titleText?: string;
  socialMediaUrl?: string;
  newTab?: string;
  platformDownloadUrl?: string;
  platformTitleText?: string;
  children?: FooterChild[];
}

export interface FooterLanguageItem extends FooterChild {
  languageCode?: string;
  languageDisplayLabel?: string;
  languageDropDownLabel?: string;
  languageLabel?: string;
  defaultSelector?: string;
  redirectionUrl?: string;
  vanityPath?: string;
}

export type FooterSectionKey =
  | "languages"
  | "applicationForms"
  | "productsPortfolio"
  | "calculators"
  | "importantLinks"
  | "reachUs";

export const panelTitleBySectionKey: Record<Exclude<FooterSectionKey, "languages">, string> = {
  applicationForms: "row1",
  productsPortfolio: "row2",
  calculators: "row3",
  importantLinks: "row4",
  reachUs: "row5",
};

export const defaultSectionTitleByKey: Record<FooterSectionKey, string> = {
  languages: "Languages",
  applicationForms: "Application Forms",
  productsPortfolio: "Products Portfolio",
  calculators: "Calculators",
  importantLinks: "Important Links",
  reachUs: "Reach Us",
};

export interface GlobalFooterProps {
  content: IFooter;
}
